import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { FeedbackEvaluationResource } from "../types/feedback";

const eventFeedbackEvaluationsKey = (eventId: Id) => ["events", `${eventId}`, "feedback-evaluation"];
export const eventFeedbackEvaluationService = {
	eventFeedbackEvaluationsKey,
	getEventFeedbackEvaluation: (eventId: Id) =>
		axios.get<LaravelResponse<FeedbackEvaluationResource[]>>(keyToUrl(eventFeedbackEvaluationsKey(eventId))),
};
